import * as React from "react";
import { GatsbySeo } from "gatsby-plugin-next-seo";

const NoIndex: React.FC = () => (
  <GatsbySeo noindex />
);
export default NoIndex;
